<template>
  <ts-card>
    <div
      class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
    >
      <h4 class="ts-text-sm ts-text-blue-600">{{ title }}</h4>
      <ts-modal-close-button />
    </div>
    <ts-card-wrapper>
      <div class="form-group">
        <label class="control-label required">{{
          $t('schedule.subjectName')
        }}</label>
        <treeselect
          class="vue-treeselect-menu"
          :options="
            subjects.map(i => ({
              id: i.subject_id,
              label: i.subject_name + ' | ' + i.subject_code
            }))
          "
          :placeholder="$t('typeForSearch')"
          v-model="detail.subject_id"
          @input="detail.teacher_id = null"
        />
        <div class="validate" v-if="errors.has('subject_id')">
          {{ errors.first('subject_id') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">{{ $t('schedule.teacherName') }}</label>
        <select v-model="detail.teacher_id" class="form-control">
          <option :value="null">{{ $t('select') }}</option>
          <option
            v-for="teacher in teachers"
            :key="teacher.teacher_id"
            :value="teacher.teacher_id"
            >{{ teacher.full_name_en }}</option
          >
        </select>
      </div>
      <div class="form-group">
        <label class="control-label">{{ $t('schedule.room') }}</label>
        <select v-model="detail.room_id" class="form-control">
          <option :value="null">{{ $t('select') }}</option>
          <option
            v-for="room in rooms"
            :key="room.room_id"
            :value="room.room_id"
            >{{ room.room_name + '|' + room.floor_no }}
            {{ room.building ? '|' + room.building.building_name : '' }}</option
          >
        </select>
      </div>
      <div class="mt-6 text-right">
        <ts-button
          class="btn-primary mr-2"
          @click.prevent="save"
          :waiting="saving"
          >{{ $t('save') }}</ts-button
        >
        <ts-button class="btn-default" @click="$emit('close')">{{
          $t('cancel')
        }}</ts-button>
      </div>
    </ts-card-wrapper>
  </ts-card>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'schedule-class-form',
  props: ['scheduleDetail'],
  data() {
    return {
      detail: Object.assign({}, this.scheduleDetail),
      saving: false,
      errors: new Errors()
    }
  },
  computed: {
    ...mapState('schedule', {
      subjects: 'academicSubjects',
      rooms: 'rooms'
    }),
    title() {
      if (this.scheduleDetail === null) return ''

      return (
        this.scheduleDetail.weekday.wd_name_en +
        ' (' +
        this.scheduleDetail.schedule_time.sc_from_time +
        '-' +
        this.scheduleDetail.schedule_time.sc_to_time +
        ')'
      )
    },
    teachers() {
      const subject = this.subjects.find(
        s => s.subject_id == this.detail.subject_id
      )

      if (subject === undefined) return []

      return subject.teachers
    }
  },
  methods: {
    ...mapActions('schedule', ['updateClass']),
    save() {
      this.errors = new Errors()
      this.saving = true

      this.updateClass({
        sch_id: this.detail.sch_id,
        data: {
          counter: this.detail.counter,
          subject_id: this.detail.subject_id,
          room_id: this.detail.room_id,
          teacher_id: this.detail.teacher_id
        }
      })
        .then(response => {
          this.saving = false

          this.$store.commit('schedule/SET_FOUND_DATA', response.schedule_class)

          this.$toasted.success(response.message)
          this.$emit('close')
        })
        .catch(error => {
          this.saving = false
          this.errors = new Errors(error.errors)

          this.$toasted.error(error.message)
        })
    }
  }
}
</script>

<style scoped>
:deep(.vue-treeselect-menu) {
  max-height: 200px !important;
  overflow-y: auto !important;
}
</style>

